import { render, staticRenderFns } from "./CardCreatingHistory.vue?vue&type=template&id=70929e8c&scoped=true&"
import script from "./CardCreatingHistory.vue?vue&type=script&lang=js&"
export * from "./CardCreatingHistory.vue?vue&type=script&lang=js&"
import style0 from "./CardCreatingHistory.vue?vue&type=style&index=0&id=70929e8c&prod&lang=scss&scoped=true&"
import style1 from "./CardCreatingHistory.vue?vue&type=style&index=1&id=70929e8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70929e8c",
  null
  
)

export default component.exports